
import "C:/Users/ZhangXu/Desktop/zproject/1/jy_platform_2.0/src/settings/styles/settings/menu_header_render.less?modules";
export default {"menuHeaderRender-content-icon": `menuHeaderRender-content-icon-UOzH7hJw`}
